import React, { useState, useEffect } from "react";
import {
  Modal,
  Alert,
  Checkbox,
  Form,
  Input,
  Radio,
  Card,
  Divider,
  Steps,
  Select,
  Tag,
  Image,
  Row,
  Col,
  List,
  Avatar,
  DatePicker,
  Dropdown,
  Button,
  Menu,
  Typography,
  Space,
  message,
  Spin,
} from "antd";
import "./TableBooking.css";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import axios from "axios";
import { observer } from "mobx-react-lite";
import { useNavigate, useLocation } from "react-router-dom";

import { useAuth } from "../../../layouts/auth/AuthContext";
import { mstBooking, mstGeneral } from "../../../mobx";
import Navbar from "../../../layouts/navbar";
import { useTable } from "./TableContext";
import { useReferral } from "../../../utils/referral";
import Footer from "../../../layouts/footer";

const { Text, Link, Title } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Step } = Steps;
const { TextArea } = Input;

const TableList = observer((props: any) => {
  const { table, fetchTable, onCurrentBooking } = useTable();
  const { user } = useAuth();
  const { navigateWithReferral } = useReferral();
  const [initialLoading, setInitialLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const navProps = useLocation();
  const [currentStep, setCurrentStep] = useState(1);
  const [paymentStatus, setPaymentStatus] = useState("success");
  const [rooms, setRooms] = useState([]);

  const [checkoutDate, setCheckoutDate] = useState("");

  const [roomQty, setRoomQty] = useState(1);
  const [searchDropdownVisible, setSearchDropdownVisible] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [searching, setSearching] = useState(false);
  const [payingNow, setPayingNow] = useState(false);
  const [loginAlertVisible, setLoginAlertVisible] = useState(false);
  const [filled, setFilled] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [priceType, setPriceType] = useState(0);
  const [specialRequest, setSpecialRequest] = useState("");
  const [checkedAddons, setCheckedAddons] = useState([]);
  const [checkedAddonDetails, setCheckedAddonDetails] = useState([]);
  const [openDatepicker, setOpenDatepicker] = useState(false);
  const [visibleDropdown, setVisibleDropdown] = useState(false);

  const [selectedRestaurant, setSelectedRestaurant] = useState<any>(null);
  const [adultPax, setAdultPax] = useState(2);
  const [childPax, setChildPax] = useState(0);
  const [checkinDate, setCheckinDate] = useState("");

  const onSelectProduct = (product: any, selectedTable: any) => {
    onCurrentBooking({
      selectedProduct: product,
      bookingParams: {
        store_id: product.store_id,
        datereserve: checkinDate,
        timereserve: selectedTable,
        number_adult: adultPax,
        number_child: childPax,
        name,
        phone,
        email,
      },
    });
    console.log("check currentBooking ===> ", {
      selectedProduct: product,
      bookingParams: {
        store_id: product.store_id,
        datereserve: checkinDate,
        timereserve: selectedTable,
        number_adult: adultPax,
        number_child: childPax,
        name,
        phone,
        email,
      },
    });
    navigateWithReferral("checkout");
    // setSelectedRoom(product);
    // setCurrentStep(2);
    // setPriceType(priceType)
    onAutofillForm(true);
  };

  const onOpenDatepicker = () => {
    console.log("onOpenDatepicker");
    setOpenDatepicker(true);
  };

  const onChangeDate = (date: any) => {
    console.log("onChangeDate");
    // console.log("Check date ===> ", date)
    setCheckinDate(date);
    // setCheckoutDate(date[1])
    setOpenDatepicker(false);
  };

  const onOpenChange = () => {
    console.log("onOpenChange");
    setOpenDatepicker(!openDatepicker);
  };

  const onSelectRestaurant = (value: any) => {
    setSelectedRestaurant(value);
  };

  const onVisibleDropdown = () => {
    setVisibleDropdown(!visibleDropdown);
  };

  const onAutofillForm = (checked: any) => {
    console.log("check onAutofillForm ===> ", checked);
    if (checked) {
      setFilled(checked);
      setName(
        `${user?.firstname !== undefined ? user?.firstname : ""}${
          user?.lastname !== undefined ? " " + user?.lastname : ""
        }`
      );
      setEmail(`${user?.email !== undefined ? user?.email : ""}`);
      setPhone(`${user?.phone !== undefined ? user?.phone : ""}`);
    } else {
      setFilled(checked);
      setName("");
      setEmail("");
      setPhone("");
    }
  };

  const onPayNow = () => {
    setPayingNow(true);
    const params = {
      UUID: user?.UUID,
      // RoomId: selectedRoom?.RoomId,
      Price_type: priceType,
      checkin_date: checkinDate,
      checkout_date: checkoutDate,
      adult_pax: adultPax,
      child_pax: childPax,
      room_qty: roomQty,
      Booking_Name: name,
      Booking_Email: email,
      Booking_Phone: phone,
      SpecialRequest: specialRequest,
    };
    const addonParams = [...checkedAddonDetails];
    mstBooking
      .createBooking(params, addonParams)
      .then((response) => {
        // createBooking api success
        mstBooking
          .createPayment({
            UUID: user?.UUID,
            order_number: response.order_number,
            paytype: 0,
          })
          .then((response) => {
            console.log(
              "Check response createPayment at home.js ===> ",
              response
            );
            // createPayment api success
            window.location.replace(response);
          })
          .catch((error) => {
            console.log("Check error createPayment at home.js ===> ", error);
            // createPayment api failed / error
            setPayingNow(false);
          });
      })
      .catch((error) => {
        console.log("Check response createBooking at home.js ===> ", error);
        // createBooking api failed / error
        setPayingNow(false);
      });
  };

  const onChangeQuantity = (type: any, action: any) => {
    const adultMax = 20; // up to 20 pax maximum
    const childMax = 20; // up to 20 pax maximum
    const roomMax = 20; // up to 20 pax maximum

    if (type === "adultPax") {
      if (action === "minus") {
        if (adultPax > 0) {
          setAdultPax(adultPax - 1);
        } else {
          console.log("Already reached minimum");
        }
      } else if (action === "add") {
        if (adultPax < adultMax) {
          setAdultPax(adultPax + 1);
        } else {
          console.log("Already reached maximum");
        }
      }
    } else if (type === "childPax") {
      if (action === "minus") {
        if (childPax > 0) {
          setChildPax(childPax - 1);
        } else {
          console.log("Already reached minimum");
        }
      } else if (action === "add") {
        if (childPax < childMax) {
          setChildPax(childPax + 1);
        } else {
          console.log("Already reached maximum");
        }
      }
    } else if (type === "roomQty") {
      if (action === "minus") {
        if (roomQty > 0) {
          setRoomQty(roomQty - 1);
        } else {
          console.log("Already reached minimum");
        }
      } else if (action === "add") {
        if (roomQty < roomMax) {
          setRoomQty(roomQty + 1);
        } else {
          console.log("Already reached maximum");
        }
      }
    }
  };

  const onSearch = () => {
    if (!checkinDate) {
      onOpenDatepicker();
      message.error("Please select a date");
      return;
    }

    if (!selectedRestaurant) {
      message.error("Please select a restaurant");
      return;
    }

    setSearching(true);
    setHasSearched(true);

    fetchTable({
      name: selectedRestaurant?.name,
      date: checkinDate,
      adultPax: adultPax,
      childPax: childPax,
    })
      .then((response: any) => {
        setSearching(false);
        setRooms(response);
      })
      .catch((error: any) => {
        setSearching(false);
        setRooms([]);
        message.error("Failed to search tables. Please try again.");
        console.log(error);
      });
  };

  const [restaurantListModalVisible, setRestaurantListModalVisible] =
    useState(false);
  // const [selectedRestaurant, setSelectedRestaurant] =
  // useState(false);
  const [restaurants, setRestaurants] = useState([]);

  const loadRestaurants = () => {
    mstGeneral
      .fetchRestaurants()
      .then((response: any) => {
        setRestaurants(response);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  useEffect(() => {
    loadRestaurants();
  }, []);

  // const onOpenPriceSummaryModal = (item) => {
  //   console.log("check onOpenPriceSummaryModal ===> ", item);
  //   setPriceSummaryModalData(item);
  //   setPriceSummaryModalVisible(true);
  // };

  const menu = (
    <Menu style={{ padding: "1em" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1em",
        }}
      >
        <Text style={{ fontSize: 16 }}>Adult</Text>
        <div>
          <Button
            type="link"
            style={{
              fontSize: 20,
              marginRight: "1em",
              marginTop: 0,
              padding: "0em",
            }}
            onClick={(e) => {
              onChangeQuantity("adultPax", "minus");
            }}
          >
            -
          </Button>
          <Text style={{ fontSize: 16 }}>
            <b>{adultPax}</b>
          </Text>
          <Button
            type="link"
            style={{
              fontSize: 20,
              marginLeft: "1em",
              marginTop: 0,
              padding: "0em",
            }}
            onClick={(e) => {
              onChangeQuantity("adultPax", "add");
            }}
          >
            +
          </Button>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1em",
        }}
      >
        <Text style={{ fontSize: 16 }}>Child</Text>
        <div>
          <Button
            type="link"
            style={{
              fontSize: 20,
              marginRight: "1em",
              marginTop: 0,
              padding: "0em",
            }}
            onClick={(e) => {
              onChangeQuantity("childPax", "minus");
            }}
          >
            -
          </Button>
          <Text style={{ fontSize: 16 }}>
            <b>{childPax}</b>
          </Text>
          <Button
            type="link"
            style={{
              fontSize: 20,
              marginLeft: "1em",
              marginTop: 0,
              padding: "0em",
            }}
            onClick={(e) => {
              onChangeQuantity("childPax", "add");
            }}
          >
            +
          </Button>
        </div>
      </div>
      {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
	  		<Text style={{ fontSize: 16 }}>Room</Text>
	  		<div>
	  			<Button type="link" style={{ fontSize: 20, marginRight: '1em', marginTop: 0, padding: '0em' }} onClick={(e) => { onChangeQuantity("roomQty", "minus") }}>-</Button>
	  			<Text style={{ fontSize: 16 }}><b>{roomQty}</b></Text>
	  			<Button type="link" style={{ fontSize: 20, marginLeft: '1em', marginTop: 0, padding: '0em' }} onClick={(e) => { onChangeQuantity("roomQty", "add") }}>+</Button>
	  		</div>
	  	</div> */}
    </Menu>
  );

  let prices = [];
  for (let i = 0; i < roomQty; i++) {
    prices.push({ value: i + 1 });
  }

  const renderStatus = (status: any) => {
    return status === "1" ? (
      <Tag color="green">Open</Tag>
    ) : (
      <Tag color="red">Closed</Tag>
    );
  };

  return (
    <div id="HomeScreen">
      <div className="container">
        <Navbar />
        <>
          <div id="searchSection">
            <Title level={4}>Table Reservation</Title>

            {/* <div style={{ marginBottom: 20 }}> */}
            {/* <RangePicker 
						open={openDatepicker}
						onOpenChange={() => { onOpenChange() }}
						className="rangePickerSearch"
            size="large" 
            placeholder={["Check in", "Check out"]} 
            onChange={(date, dateString) => { onChangeDate(dateString) }} 
            disabledDate={(current) => {
              return moment().add(-1, 'days')  >= current
            }}
          /> */}
            <Row gutter={[16, 16]} align="middle">
              <Col xs={24} sm={12} md={10} lg={8} xl={24}>
                <div style={{ width: "100%", marginBottom: 10 }}>
                  <div style={{ marginBottom: 5 }}>Restaurant</div>
                  <Button
                    onClick={() => {
                      setRestaurantListModalVisible(true);
                    }}
                    size="large"
                    style={{ width: "100%", textAlign: "left" }}
                  >
                    {selectedRestaurant?.name
                      ? selectedRestaurant?.name
                      : "Please select restaurant"}
                  </Button>
                </div>
              </Col>
            </Row>
            <Row gutter={[16, 16]} align="middle">
              <Col xs={24} sm={12} md={10} lg={8} xl={12}>
                <div style={{ marginBottom: 5 }}>Pax</div>
                {/* @ts-ignore */}
                <Dropdown
                  // style={{ width: "100%" }}
                  visible={visibleDropdown}
                  onVisibleChange={onVisibleDropdown}
                  // className="dropdownSearch"
                  trigger={["hover"]}
                  overlay={menu}
                  placement="bottomRight"
                  arrow
                >
                  <Button size="large" style={{ width: "100%" }}>
                    {adultPax} Adult &nbsp;·&nbsp; {childPax} Child
                  </Button>
                </Dropdown>
              </Col>
              <Col xs={24} sm={12} md={10} lg={8} xl={12}>
                <div>
                  <div style={{ marginBottom: 5 }}>Date</div>
                  <DatePicker
                    open={openDatepicker}
                    onOpenChange={() => {
                      onOpenChange();
                    }}
                    // className="rangePickerSearch"
                    size="large"
                    placeholder={"Reservation Date"}
                    onChange={(date, dateString) => {
                      onChangeDate(dateString);
                    }}
                    disabledDate={(current) => {
                      return moment().add(-1, "days") >= current;
                    }}
                    style={{ width: "100%" }}
                  />
                </div>
              </Col>
            </Row>

            {/* </div> */}
            <Row style={{ marginTop: 15 }} gutter={[16, 16]} align="middle">
              <Col xs={24} sm={12} md={10} lg={8} xl={24}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    className="buttonSearch"
                    loading={searching}
                    style={{
                      width: "100%",
                      backgroundColor: "#e90056",
                      borderColor: "#e90056",
                    }}
                    size="large"
                    type="primary"
                    onClick={() => {
                      // @ts-ignore
                      onSearch();
                    }}
                  >
                    {/* @ts-ignore */}
                    <SearchOutlined />
                    Search Table
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
          <div className="productListWrapper">
            <Divider />
            <div style={{ paddingBottom: 5 }}>
              <Title level={5}>Available Time Slots</Title>
            </div>

            {/* Loading State */}
            {searching && (
              <div
                style={{
                  textAlign: "center",
                  padding: "40px 20px",
                  backgroundColor: "#fafafa",
                  borderRadius: 8,
                }}
              >
                <Spin size="large" />
                <div style={{ marginTop: 16 }}>
                  <Text>Searching for available time slots...</Text>
                </div>
              </div>
            )}

            {/* No Search Performed */}
            {!hasSearched && !searching && (
              <div
                style={{
                  textAlign: "center",
                  padding: "60px 20px",
                  backgroundColor: "#fafafa",
                  borderRadius: 8,
                }}
              >
                <div style={{ fontSize: 64, marginBottom: 16 }}>🍽️</div>
                <Title level={4} style={{ color: "#6c757d", marginBottom: 8 }}>
                  Find Your Perfect Table
                </Title>
                <Text type="secondary">
                  Please select a restaurant, date, and search to see available
                  time slots
                </Text>
              </div>
            )}

            {/* No Results Found */}
            {hasSearched &&
              !searching &&
              (!table.timeSlots || table.timeSlots.length === 0) && (
                <div
                  style={{
                    textAlign: "center",
                    padding: "60px 20px",
                    backgroundColor: "#fafafa",
                    borderRadius: 8,
                  }}
                >
                  <div style={{ fontSize: 64, marginBottom: 16 }}>😔</div>
                  <Title
                    level={4}
                    style={{ color: "#6c757d", marginBottom: 8 }}
                  >
                    No Tables Available
                  </Title>
                  <Text type="secondary">
                    No available time slots found for {selectedRestaurant?.name}{" "}
                    on {moment(checkinDate).format("DD MMM YYYY")}.
                  </Text>
                  <br />
                  <Text type="secondary">
                    Please try a different date or contact the restaurant
                    directly.
                  </Text>
                  <div style={{ marginTop: 16 }}>
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "#e90056",
                        borderColor: "#e90056",
                      }}
                      onClick={onSearch}
                    >
                      Search Again
                    </Button>
                  </div>
                </div>
              )}

            {/* Available Time Slots */}
            {hasSearched &&
              !searching &&
              table.timeSlots &&
              table.timeSlots.length > 0 && (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: 16,
                    }}
                  >
                    <div>
                      <Text strong>
                        Found {table.timeSlots.length} available time slots
                      </Text>
                      <br />
                      <Text type="secondary">
                        at {selectedRestaurant?.name} on{" "}
                        {moment(checkinDate).format("DD MMM YYYY")}
                      </Text>
                    </div>
                    <Button onClick={onSearch} type="default">
                      Refresh
                    </Button>
                  </div>

                  <Row gutter={[8, 8]}>
                    {table.timeSlots.map((slot: any, index: number) => (
                      <Col key={index} xs={12} sm={8} md={6} lg={4}>
                        <Card
                          size="small"
                          onClick={() => onSelectProduct(table, slot)}
                          style={{
                            cursor: "pointer",
                            border: "1px solid #d9d9d9",
                            borderRadius: "8px",
                            textAlign: "center",
                            transition: "all 0.3s ease",
                          }}
                          bodyStyle={{ padding: "12px 8px" }}
                          hoverable
                        >
                          <div style={{ marginBottom: "8px" }}>
                            <Text strong style={{ fontSize: "16px" }}>
                              {slot.time_slot}
                            </Text>
                          </div>
                          <div style={{ marginBottom: "4px" }}>
                            <Text type="secondary" style={{ fontSize: "12px" }}>
                              Tables Left: {slot.Table_Left}
                            </Text>
                          </div>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </>
              )}
          </div>
          {/* @ts-ignore */}
          <Modal
            title="Restaurant List"
            visible={restaurantListModalVisible}
            footer={null}
            onCancel={() => setRestaurantListModalVisible(false)}
          >
            <List
              itemLayout="horizontal"
              dataSource={restaurants}
              renderItem={(rest: any) => (
                <List.Item
                  onClick={() => {
                    if (rest.status === "0") {
                      alert(
                        "Restaurant is closed. Please try again or select another option. Thank you!"
                      );
                      return;
                    }
                    onSelectRestaurant(rest);
                    setRestaurantListModalVisible(false);
                  }}
                  style={{
                    cursor: "pointer",
                    borderBottom: "1px solid #f0f0f0",
                    padding: "12px 0",
                  }}
                >
                  <List.Item.Meta
                    avatar={
                      <Avatar
                        shape="square"
                        size={64}
                        src={rest.logo_url || rest.images}
                      />
                    }
                    title={
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span>{rest.name}</span>
                        {renderStatus(rest.status)}
                      </div>
                    }
                    description={
                      <div>
                        <div>{rest.address}</div>
                        <div>{rest.phone_number}</div>
                      </div>
                    }
                  />
                </List.Item>
              )}
            />
          </Modal>
        </>
        <Footer />
      </div>
    </div>
  );
});

export default TableList;
